export default __webpack_public_path__ + "media/images/mastodon-3077f2d7a2988b7926e5d13856ef4259.jpg";